import { Box, styled } from '@mui/material';

export const OptionsCardContainerV3 = styled(Box, {
  shouldForwardProp: (prop: string) => !['isDisabled'].includes(prop),
})<{ isDisabled?: boolean }>(({ theme, isDisabled }) => ({
  position: 'relative',
  width: '100%',
  padding: '12px',
  marginBottom: '12px',
  '&:last-child': {
    marginBottom: '0',
  },
  [theme.breakpoints.down('sm')]: {
    marginBottom: '8px',
  },
  borderRadius: '8px',
  border: `1px solid ${theme.palette.case.neutral.n200}`,
  backgroundColor: theme.palette.case.neutral.n0,
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.case.neutral.n75,
  },
  '&:active': {
    backgroundColor: theme.palette.case.neutral.n100,
  },
  ...(isDisabled && {
    cursor: 'auto',
  }),
}));

export const OptionsCardIconContainerV3 = styled(Box, {
  shouldForwardProp: (prop: string) => !['isDisabled'].includes(prop),
})<{ isDisabled?: boolean }>(({ theme, isDisabled }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: '0',

  marginRight: '8px',
  svg: {
    width: '24px',
    height: '24px',
    path: {
      fill: isDisabled ? theme.palette.case.neutral.n300 : theme.palette.case.neutral.n600,
    },
  },
}));
